import { createContext, useContext } from 'react';

type ManualPreviewContextValue = {
  previewOpen: boolean;
  openPreview: () => void;
  closePreview: () => void;
  togglePreview: () => void;
};

const ManualPreviewContext = createContext<ManualPreviewContextValue>({
  previewOpen: false,
  openPreview: () => undefined,
  closePreview: () => undefined,
  togglePreview: () => undefined,
});

export function ManualPreviewProvider({
  value,
  children,
}: {
  value: ManualPreviewContextValue;
  children: React.ReactNode;
}) {
  return (
    <ManualPreviewContext.Provider value={value}>
      {children}
    </ManualPreviewContext.Provider>
  );
}

export function useManualPreview() {
  return useContext(ManualPreviewContext);
}
